export const DEFAULT_APPOINTMENT_REMINDER_TEMPLATE_NAME = 'lembrete_reuniao';

export const DEFAULT_LEMBRETE_REUNIAO_PROCESSED_PARAMS = {
  1: '{{ contact.name }}',
  2: '{{ appointment.time_remaining }}',
  3: '{{ appointment.date }}',
  4: '{{ appointment.time }}',
  5: '{{ appointment.link }}',
};

export const defaultProcessedParamsForTemplate = templateName => {
  if (templateName === DEFAULT_APPOINTMENT_REMINDER_TEMPLATE_NAME) {
    return { ...DEFAULT_LEMBRETE_REUNIAO_PROCESSED_PARAMS };
  }

  return null;
};

export const findDefaultAppointmentReminderTemplateOption = templateOptions =>
  templateOptions.find(
    option => option.value === DEFAULT_APPOINTMENT_REMINDER_TEMPLATE_NAME
  ) || null;
